import { html } from 'uhtml';

export class ESliderBubble {
  createElement() {
    return html.node`
      <div class="e-slider-bubble__handle">
        <e-icon icon="e-caret-horizontal" color="highlight" size="small"></e-icon>
      </div>
    `;
  }
}

